module.exports = __webpack_public_path__ + "img/info.239a9cd6.svg";